import { useState, useEffect } from 'react'

// Global state for synchronized countdown
let globalTimeLeft = 643 // 10 min 43 sec
let listeners: ((time: number) => void)[] = []
let intervalId: NodeJS.Timeout | null = null

const startInterval = () => {
  if (!intervalId) {
    intervalId = setInterval(() => {
      globalTimeLeft = Math.max(0, globalTimeLeft - 1)
      listeners.forEach((listener) => listener(globalTimeLeft))
      if (globalTimeLeft === 0 && intervalId) {
        clearInterval(intervalId)
      }
    }, 1000)
  }
}

export const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.push(setTimeLeft)
    startInterval()

    return () => {
      listeners = listeners.filter((l) => l !== setTimeLeft)
    }
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isZero: timeLeft === 0,
  }
}
